import { ApiService } from '@ligo/shared/utils';
import { RESOURCES } from '@ligo/bv-flow/store';
import { BasicFieldType } from '@ligo/shared/mvc';
import Vue from 'vue';

export const loginFormLayout = [['email'], ['password']];

export const registerFormLayout = [
  ['firstname', 'lastname'],
  ['phone'],
  ['email'],
  ['password'],
  ['password_confirmation']
];

const googleBtn = {
  icon: 'img:/questionnaire/icons/google.svg',
  label: 'google',
  provider: 'google_oauth2'
};

const linkedinBtn = {
  icon: 'img:/questionnaire/icons/linkedin.svg',
  label: 'linkedin',
  provider: 'linkedin'
};

export const providerLinks = {
  google_oauth2: RESOURCES.GOOGLEOAUTH,
  linkedin: RESOURCES.LINKEDINOAUTH
};

export type SocialProvider = keyof typeof providerLinks;

export const socialBtns = [googleBtn, linkedinBtn];

export const socialAuth = (
  provider: SocialProvider,
  redirect_url = '/questionnaire'
) => {
  const redirection = `&auth_redirect_url=${redirect_url}`;
  window.open(
    `${providerLinks[provider] + window.location.host}/questionnaire${redirection}`,
    '_self'
  );
};

const fieldsToDict = (fields: BasicFieldType[]) => {
  const result: { [id: string]: any } = {};
  fields.forEach((field) => {
    result[field.key] = field.value;
  });
  return result;
};

export const useLogin = () => {
  const performLogin = async (fields: BasicFieldType[]) => {
    const result: boolean = await Vue['Store'].dispatch('authentication/auth', {
      data: fieldsToDict(fields)
    });
    return result;
  };
  return { performLogin };
};

export const useRegister = () => {
  const performRegister = async (
    fields: BasicFieldType[],
    remainingParams = {}
  ) => {
    const result: boolean = await Vue['Store'].dispatch('authentication/auth', {
      data: {
        ...fieldsToDict(fields),
        ...remainingParams,
        confirm_success_url: RESOURCES.CONFIRMATION
      },
      registration: true
    });
    return result;
  };
  return { performRegister };
};

export const sendConfirmationEmail = (email: string) => {
  return ApiService.post(RESOURCES.RETRY_CONFIRMATION, { email });
};
